export default class ReviewsController {
    constructor(wrapper, options = {}) {
        if (!wrapper) return;

        this.wrapper = wrapper;
        this.reviews = Array.from(
            wrapper.querySelectorAll('.customer-review')
        );

        this.pageSize =
            Number(wrapper.dataset.pageSize) ||
            options.pageSize ||
            2;

        this.controls = {
            prev: document.querySelector('[data-review-prev]'),
            next: document.querySelector('[data-review-next]'),
            more: document.querySelector('[data-review-more]')
        };

        // Unified state
        this.startIndex = 0;
        this.visibleCount = this.pageSize;

        this._bindEvents();
        this._render();
    }

    _bindEvents() {
        this.controls.prev?.addEventListener('click', () => this.prev());
        this.controls.next?.addEventListener('click', () => this.next());
        this.controls.more?.addEventListener('click', () => this.showMore());
    }

    _hideAll() {
        this.reviews.forEach(r => r.classList.remove('active'));
    }

    _showRange(start, count) {
        this._hideAll();
        this.reviews
            .slice(start, start + count)
            .forEach(r => r.classList.add('active'));
    }

    _updateButtons() {
        const { prev, next, more } = this.controls;
        const endIndex = this.startIndex + this.visibleCount;

        if (prev) prev.disabled = this.startIndex === 0;
        if (next) next.disabled = endIndex >= this.reviews.length;
        if (more) more.disabled = endIndex >= this.reviews.length;
    }

    _render() {
        this._showRange(this.startIndex, this.visibleCount);
        this._updateButtons();
    }

    next() {
        const nextStart = this.startIndex + this.visibleCount;
        if (nextStart < this.reviews.length) {
            this.startIndex = nextStart;
            this.visibleCount = this.pageSize;
            this._render();
        }
    }

    prev() {
        const prevStart = this.startIndex - this.pageSize;
        if (prevStart >= 0) {
            this.startIndex = prevStart;
            this.visibleCount = this.pageSize;
            this._render();
        }
    }

    showMore() {
        const remaining = this.reviews.length - this.startIndex;
        this.visibleCount = Math.min(
            this.visibleCount + this.pageSize,
            remaining
        );
        this._render();
    }
}
